var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M.6 9.155s.085.66 2.545 3.394 6.45 2.734 8.91 0a7.2 7.2 0 0 0 1.688-3.394M.6 9.155v4.667m0-4.667h4.2m9.8-3.11s-.085-.661-2.546-3.395-6.449-2.734-8.91 0a7.2 7.2 0 0 0-1.688 3.394m13.144 0V1.377m0 4.667h-4.2"
  })));
};
export default SvgRefresh;